import { atom } from 'jotai';
import { atomWithStorage, createJSONStorage } from 'jotai/utils';

import { CI_RETURN_URL } from './constants';

const TERMS_APPROVAL_DATA_KEY = 'bznav-refund-terms-data';

const sessionJSONStorage = createJSONStorage<Record<string, boolean> | undefined>(() => sessionStorage);
export const termsApprovalStateAtom = atomWithStorage<Record<string, boolean> | undefined>(TERMS_APPROVAL_DATA_KEY, undefined, sessionJSONStorage);

export const isPreventRouteChangeAtom = atom<boolean>(false);

export const ciReturnUrlAtom = atomWithStorage<string | null>(
  CI_RETURN_URL,
  null,
  createJSONStorage(() => sessionStorage)
);
